import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { TanstackDevtools } from 'new-components/TanstackDevtools/TanstackDevtools';
import { AppProvider } from 'new-components/OpAppScaffold/components/AppContext';

import { useCreateQueryClient } from '../app/utils/customHooks/useCreateQueryClient';

import { OpPartnerAppScaffold } from './OpPartnerAppScaffold';

import './App.scss';

/**
 * @component
 * @description Component that wraps the partner center app and holds the top level functionality.
 */
export const App = () => {
  // Create a react-query client
  const queryClient = useCreateQueryClient();

  return (
    <AppProvider app="partnerCenter">
      <QueryClientProvider client={queryClient}>
        <OpPartnerAppScaffold />
        <TanstackDevtools />
      </QueryClientProvider>
    </AppProvider>
  );
};
